import "./scss/index.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/init";
import { Provider as StoreProvider } from "react-redux";
import store from "./store";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>,
);
